<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">All Aboard Message</ion-title>
        <ion-buttons slot="end">
            <ion-button id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list lines="none">
        <ion-item color="secondary">
            Notify pending ticket holders that their courtesy shuttle is about to leave.
        </ion-item>

        <app-customer-messages 
            [config]="config" 
            [(data)]="vm" 
            [submitted]="submitted">
        </app-customer-messages>

        @if (isDebugMode) {
            <div>
                <ion-item>
                    <ion-label class="ion-text-wrap" stacked>Minutes - For Cypress Testing!</ion-label>
                    <ion-input id="numMinutes" type="text" name="debug" [(ngModel)]="settings.numMinutes"
                        data-test="numMinutes"></ion-input>
                </ion-item>
            </div>
        }
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button color="primary" expand="full" (click)="onSaveClick()" [disabled]="customerMessagesComponent?.form?.invalid"
            data-test="saveButton">Save</ion-button>
    </ion-toolbar>
</ion-footer>